module.exports = __webpack_public_path__ + "static/media/london-8.78dcff41.jpg";